<template>
  <div>
    <div class="is-flex is-align-content-center is-justify-content-center is-text-center">
      <button class="control-button-minus flex justify-center items-center" :disabled="disabled || localValue === minimum || loading" @click="change(-1)">
        <img src="@/images/quote-builder/minus.svg" alt="Minus">
      </button>
     
      <div class="order-item-quantity flex items-center justify-center">
        <p>{{ localValue }}</p>
      </div>
     
      <button class="control-button-plus flex justify-center items-center" :disabled="disabled || localValue === maximum || loading" @click="change(+1)">
        <img src="@/images/quote-builder/plus.svg" alt="Plus">
      </button>
    </div>
    <!--<a href="#" class="is-flex has-text-danger is-align-content-center is-justify-content-center is-text-center is-size-7 mt-1" @click.prevent="change(-localValue)">
      <span v-if="localValue > 1" >Reset</span>
      <span v-else>&nbsp;</span>
    </a>-->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    minimum: {
      type: Number,
      default: 1
    },
    maximum: {
      type: Number,
      default: 99
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: this.value,
      loading: false
    }
  },
  methods: {
    change (quantity) {
      this.loading = true
      this.localValue += quantity
      if (this.localValue < this.minimum) {
        this.localValue = this.minimum
      } else if (this.localValue >= this.maximum) {
        this.localValue = this.maximum
      }
      this.$emit('input', this.localValue)
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.control-button:hover {
  cursor: pointer;
  background-color: #d6d6d6;
}
.quantity-display {
  text-align: center;
  margin: 0px;
  padding: 7px 16px;
  background-color: white;
  font-weight: bold;
}
.control-button-minus {
  width: 44px;
  height: 44px;
  background-color: #f3f1ed;
  border: 1px solid #e8e3db;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.control-button-plus {
  width: 44px;
  height: 44px;
  background-color: #f3f1ed;
  border: 1px solid #e8e3db;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.is-small {
  .control-button {
    width: auto;
    padding: 4px 7px;
  }
  .quantity-display {
    padding: 5px 10px;
  }
}

.order-item-quantity {
  width: 44px;
  height: 44px;
  background-color: #FFF;
  border: 1px solid #EDE9E3;
}

.order-item-quantity p {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  color: #334155;
}

</style>
